import React from 'react';

const Team = () => {
  const teamMembers = [
    {
      name: 'Walter White',
      position: 'Chief Executive Officer',
      image: 'team-1.jpg'
    },
    {
      name: 'Sarah Jhonson',
      position: 'Product Manager',
      image: 'team-2.jpg'
    },
    {
      name: 'William Anderson',
      position: 'CTO',
      image: 'team-3.jpg'
    }
  ];

  return (
    <section id="team" className="team section">
      <div className="container section-title" data-aos="fade-up">
        <span>Section Title</span>
        <h2>Team</h2>
        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
      </div>

      <div className="container">
        <div className="row gy-5">
          {teamMembers.map((member, index) => (
            <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={100 + (index * 100)}>
              <div className="member">
                <div className="pic">
                  <img src={`/assets/img/team/${member.image}`} className="img-fluid" alt="" />
                </div>
                <div className="member-info">
                  <h4>{member.name}</h4>
                  <span>{member.position}</span>
                  <div className="social">
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-twitter-x"></i></a>
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook"></i></a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin"></i></a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
